import React from 'react';
import styles from './PFSPIIB.module.css';
import ContentContainer from '../ContentContainer/ContentContainer';
import PIIBLogo from './PIIB_logo.png';
import { NavLink, useLocation } from 'react-router-dom';
import { useBreadcrumb } from '../../hooks/useBreadcrumb';
import { PartnersIndexBreadcrumb } from '../PFSPartnersIndex/PFSPartnersIndex';

const PFSPIIB = () => {
  const { pathname } = useLocation();

  useBreadcrumb([
    PartnersIndexBreadcrumb,
    {
      label: 'PIIB',
      url: pathname,
    },
  ]);

  return (
    <div className={styles.PfsPIIB} data-testid="PfsPIIB">
      <ContentContainer>
        <img className={styles.logo} src={PIIBLogo} alt="PIIB" />
        <h1>PIIB Joins PFS Global as a Partner!</h1>
        <div className={styles.content}>
          <p>
            We are pleased to announce that PIIB has become a partner of PFS Global.
            PIIB was established in 1994 and is based in El Dorado Hills, California.
          </p>
          <p>
            PIIB is a privately owned network representing 260+ independent
            insurance agencies across nine states, with more than $1 billion written
            premium and direct access to 60+ carrier partners. Backed by 40 affiliate
            owners, PIIB is committed to preserving the independent agency model
            while providing the relationships, resources, and opportunities that support
            long-term agency growth and success.
          </p>
          <p>
            This collaboration allows us to integrate PIIB's extensive network
            and expertise into our offerings, ensuring that we deliver enhanced
            value and efficiency to you, our esteemed clients.
          </p>
          <p>
            For more information about PIIB, please visit{' '}
            <a href="https://www.piib.com">www.piib.com</a>, or reach
            out directly at <a href="mailto:opportunity@piib.com">opportunity@piib.com</a>.
          </p>
          <p>
            We are excited about the opportunities this partnership presents and
            are available to address any inquiries or feedback you may have.
          </p>
          <NavLink to={'/who-we-trust'} id={styles.homeBtn}>
            Back to Who We Trust
          </NavLink>
        </div>
      </ContentContainer>
    </div>
  );
};

export default PFSPIIB;